import { AxiosResponse } from 'axios'
import ajustarUsuario from 'Hooks/usuario/ajustarUsuario'
import { Usuario, UsuariosRequestState } from 'Hooks/usuario/types'
import { useEffect, useState } from 'react'
import usuarioApiService from 'Services/api/usuario'
import { UsuarioApi } from 'Services/api/usuario/types'

interface UseUsuariosResult {
  usuariosRequest: UsuariosRequestState
}

const useUsuarios = (): UseUsuariosResult => {
  const [data, setData] = useState<Usuario[]>([])
  const [hasError, setHasError] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    usuarioApiService
      .list()
      .then((response: AxiosResponse<UsuarioApi[]>) => response.data)
      .then((usuarios: UsuarioApi[]) => usuarios.map(ajustarUsuario))
      .then(setData)
      .catch((error: unknown) => {
        console.error(error)
        setHasError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return {
    usuariosRequest: {
      data,
      hasError,
      isLoading,
    },
  }
}

export default useUsuarios
